import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/notification.service';
import CompanyService from '../../../services/company.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../reducers/upload';

const imageSelector = uploadSelectors.getTempFile('image');

const mapStateToProps = state => ({
  image: imageSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
};

const defaultFormData = {
  name: '',
  status: 1,
  type: 1,
  is_default: 0,
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { image, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    image: image && image.id ? image.id : '',
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('image');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('countries', 'setCountries', []),
  withState('searchCity', 'setSearchCity', ''),
  withState('companiesList', 'setCompaniesList', []),
  defaultProps({
    getImage: ModelService.getImage,
    tab: () => '<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>',
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      const companiesList = await CompanyService.getAll();
      await this.props.setCompaniesList(companiesList);

      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };
    },
  }),
  withProps(props => ({
    title: props.t('Notification') + fh.getTitleEnd(props),
    imageSrc: props.image && props.image.url
      ? props.image.url : ModelService.getImage(props.formData.image, 150, 150),
    typesList: ModelService.getTypesOptions(props.t),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/notifications/item/index.js